import React from "react";
import { Box } from "@mui/material";
import { CustomCellRendererProps } from "ag-grid-react";

import { FiberRange, SpliceRecord } from "fond/topologicalView/types";

import SpliceTypeIcon from "./SpliceTypeIcon";

type Props = { side: "input" | "output" } & Pick<CustomCellRendererProps<SpliceRecord, FiberRange>, "data" | "value">;

export const formatFiberRange = (value: FiberRange | null | undefined) => {
  if (!value) {
    return "";
  }
  const { start, end } = value;
  if (start === end) {
    return `F${start}`;
  }
  return `F${start}-${end}`;
};

/**
 * Component to render a fiber range.
 *
 * If we're rendering an input fiber range, then each row will have a corresponding
 * icon indicating what type of splice is happening at that input.
 */
const FiberCellRenderer: React.FC<Props> = ({ data, value, side }) => {
  const valueFormatted = formatFiberRange(value);
  if (side === "output") {
    return valueFormatted ?? "";
  }

  // A splice row can either represent a single fiber or a range of fibers. We use slightly different terminology
  // in the tooltip based on that.
  const multiple = (value && value.end > value.start) ?? false;

  return (
    <Box display="flex" alignItems="center" textAlign="center" justifyContent="space-between">
      <Box flex={1} textAlign="center">
        <span>{valueFormatted ?? ""}</span>
      </Box>
      {side === "input" && <SpliceTypeIcon spliceType={data?.spliceType} multiple={multiple} />}
    </Box>
  );
};

export default FiberCellRenderer;
